import React, { useContext, useState, useCallback, useRef, useEffect } from 'react'
import classnames from 'classnames'
import styles from './index.module.less'
import { AdvantageOutside } from './components/advantage'
import Superior from './components/superior'
import { IMachineConfig } from './types'
import context from './context'
import Login from './components/login'
import PoizonDownloadBar from '../../base-components/download-bar'
import { EditConfigType } from '@/typings/types'

import { useWithReactFunctionalTrack } from '@du/analytics-sdk'
import { createTrackConfig } from './track-config'

interface IProps {
  editConfig: EditConfigType
  propsConfig: IMachineConfig
  inviteCode: string
  nickname: string
  portrait: string
  linkRule: string
}

function ShareInvite(props: IProps & IMachineConfig) {
  const {
    equity,
    invite: { rule, offers, login, open1, open2, download },
  } = useContext(context)
  const { inviteCode, nickname, portrait, linkRule } = props

  const [isShow, setShow] = useState(false)

  const handleDownloadBar = useCallback((val: boolean) => {
    setShow(val)
  }, [])

  // 埋点绑定
  // 使用hook useEffect api ，当ref有值则组件渲染结束，props可挂载并执行$track函数
  const functionalRef = useRef(null)
  const functionalProps = { ...props }

  useWithReactFunctionalTrack({
    functionalRef,
    functionalProps,
    useEffect,
    createTrackConfig,
  })

  return (
    <span ref={functionalRef} data-track-exposure="poizon_activity_invitee_pageview">
      <PoizonDownloadBar {...props} isShow={isShow} callback={() => setShow(false)} />
      <div className={classnames(styles.shareInviteUi, styles[equity])}>
        <div className={styles.invitedInfo}>
          <em style={{ backgroundImage: `url(${portrait})` }} />
          <span>{nickname}</span>
          <span>{offers}</span>
          <a className={styles.activityRules} href={linkRule}>
            {rule}
          </a>
        </div>
        <AdvantageOutside flow="before" {...props} />
        <Login
          inviteCode={inviteCode}
          login={login}
          callback={handleDownloadBar}
          open1={open1}
          open2={open2}
          download={download}
        />
        <Superior />
      </div>
    </span>
  )
}

export default React.memo(ShareInvite)
